// @flow
import React from 'react';
import { Button } from '../../common';
import bigBackground from '../../../src/static/images/banner.png';

type Props = {
  channel: string,
  email: ?string,
  digits: Array<string>,
  inputsRef: any,
  onDigitChange: (index: number, value: string) => void,
  onDigitKeyDown: (index: number, e: any) => void,
  onDigitPaste: (e: any) => void,
  onSubmit: (e: SyntheticEvent<>) => void,
  secondsLeft: number,
  onResend: () => void,
  formatTime: (s: number) => string,
  verifying: boolean,
  errors?: ?any,
};

const VerifyMfaCodeStep = ({
  channel,
  email,
  digits,
  inputsRef,
  onDigitChange,
  onDigitKeyDown,
  onDigitPaste,
  onSubmit,
  secondsLeft,
  onResend,
  formatTime,
  verifying,
  errors,
}: Props) => {
  const channelLabel = channel === 'sms' ? 'SMS' : 'Email';
  const maskedEmail = email ? email.replace(/(.{2}).+(@.+)/, '$1****$2') : '';

  return (
    <div className="login-page">
      <div className="login-page-image-panel">
        <img src={bigBackground} alt="Big Delivery" className="login-page-image" />
      </div>
      <div className="login-page-form-panel">
        <h2 className="login-page-title">Digite o código enviado via {channelLabel}</h2>
        <p className="login-page-subtitle">
          Enviamos um código de 6 dígitos para {channel === 'email' ? maskedEmail : 'o seu telefone'}.
        </p>
        {errors && errors.base && errors.base.length > 0 && (
          <div className="form-control-input-message">{errors.base[0]}</div>
        )}
        <div className="login-box-main login-box-fade-in">
          <form onSubmit={onSubmit}>
            <div className="mfa-digits">
              {digits.map((d, i) => (
                <input
                  key={i}
                  ref={el => (inputsRef.current[i] = el)}
                  className="mfa-digit-input"
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={d}
                  onChange={e => onDigitChange(i, e.target.value)}
                  onKeyDown={e => onDigitKeyDown(i, e)}
                  onPaste={onDigitPaste}
                />
              ))}
            </div>
            <div className="mfa-resend">
              <span className="mfa-resend-label">Não recebeu o código?</span>
              {secondsLeft > 0 ? (
                <span className="mfa-resend-timer">Reenviar código em {formatTime(secondsLeft)}</span>
              ) : (
                <button type="button" className="mfa-resend-button" onClick={onResend}>
                  Reenviar código
                </button>
              )}
            </div>
            <Button
              text="Continuar"
              icon=""
              buttonType="button-secondary"
              loading={verifying}
              disabled={verifying || digits.some(d => d === '')}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default VerifyMfaCodeStep;
